// imports
import Component from 'minsky-kit/js/components/Component';
import { strToDom } from 'minsky-kit/js/utils/dom';
import { svgIconEl } from 'minsky-kit/js/utils/svgIcon';
import CRMultiSelect from 'minsky-kit/js/components/CRMultiSelect';

// private statics

// class definition

export default class DropdownDrupalfilter extends Component {
    // constructor
    constructor (args = {}, objectName = 'DropdownDrupalFilter') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // properties
        this._$label = Array.from(this.$el.children).find(($child) => $child.tagName.toLowerCase() === 'label');
        this.crMultiSelect = null;
        this._$content = prep.call(this);
        this._hasFocus = false;
        this._touched = false;

        // add listeners
        this.$el.addEventListener('touchstart', this.blm.add('onTouchStart', onTouchStart));
        this.$el.addEventListener('mouseenter', this.blm.add('onMouseEnter', onMouseEnter));
        this.$el.addEventListener('mouseleave', this.blm.add('onMouseLeave', onMouseLeave));
        this.$el.querySelectorAll('input, button').forEach(($item) => {
            $item.addEventListener('focus', this.blm.addOnce('onChildFocus', onChildFocus));
            $item.addEventListener('blur', this.blm.addOnce('onChildBlur', onChildBlur));
            $item.addEventListener('click', this.blm.addOnce('onChildClick', onChildClick));
        });

        this._$label.addEventListener('click', this.blm.add('onClick', onClick));

        // add classes
        this._$label.classList.add('dropdown-drupal-filter__label');
        this.$el.classList.add('dropdown-drupal-filter--hidden');

        // add arrow to label
        this._$label.append(svgIconEl('triangleDown', ['dropdown-drupal-filter__arrow']));

        // update position a first time
        updatePosition.call(this);
    }

    // methods

    destroy () {
        // remove arrow to label
        this._$label.querySelector('.dropdown-drupal-filter__arrow').remove();

        // remove classes
        this._$label.classList.remove('dropdown-drupal-filter__label');
        this.$el.classList.remove('dropdown-drupal-filter--hidden');

        // remove listeners
        this.$el.removeEventListener('mouseenter', this.blm.remove('onMouseEnter'));
        this.$el.removeEventListener('mouseleave', this.blm.remove('onMouseLeave'));
        this._$label.removeEventListener('click', this.blm.remove('onclick'));
        this.$el.querySelectorAll('input, button').forEach(($item) => {
            $item.removeEventListener('focus', this.blm.get('onChildFocus'));
            $item.removeEventListener('blur', this.blm.get('onChildBlur'));
            $item.removeEventListener('click', this.blm.get('onChildClick'));
        });

        // destroy checkboxes
        if (this.crMultiSelect) this.crMultiSelect.destroy();

        // clear el
        clear.call(this);

        // super destroy
        super.destroy();
    }

    // getters & setters
    get visible () {
        return this.$el.classList.contains('dropdown-drupal-filter--visible');
    }

    set visible (v) {
        if (v !== this.visible) {
            if (v) {
                this.$el.classList.add('dropdown-drupal-filter--visible');
                this.$el.classList.remove('dropdown-drupal-filter--hidden');
                this.dispatch('show');
                // console.log('joejoe');
                updatePosition.call(this);
            }
            else {
                this.$el.classList.remove('dropdown-drupal-filter--visible');
                this.$el.classList.add('dropdown-drupal-filter--hidden');
                // console.log('joejoe');
                this.dispatch('hide');
            }
        }
    }

    get checkboxes () {
        return this.crMultiSelect;
    }
}

// Utils
function prep () {
    // quickly wrap select in wrapper for dropdown
    const $elSelect = this.$el.querySelector('select');
    const $wrapper = createDropdownContent();
    $elSelect.parentNode.insertBefore($wrapper, $elSelect);
    $wrapper.appendChild($elSelect);

    // init checkboxes
    if ($elSelect) {
        this.crMultiSelect = new CRMultiSelect({ $el: $elSelect });
        this.crMultiSelect.on('change', this.blm.addOnce('onFilterChange', onFilterChange));
    }

    return $wrapper;
}

function clear () {
    const $elSelect = this.$el.querySelector('select');
    const $wrapper = this.$el.querySelector('.dropdown-drupal-filter__content');

    // put select back
    $wrapper.parentNode.insertBefore($elSelect, $wrapper);
    $wrapper.remove();
}

function createDropdownContent () {
    return strToDom('<div class="dropdown-drupal-filter__content"></div>');
}

function updatePosition () {
    this._$content.classList.remove('dropdown-drupal-filter--flipSide');
    this._$content.style.left = null;
    this._$content.style.width = null;

    let bb = this._$content.getBoundingClientRect();

    if (bb.left + this._$content.clientWidth > document.body.clientWidth) {
        this.$el.classList.add('dropdown-drupal-filter--flipSide');

        // check again, see if we overflow left side now
        bb = this._$content.getBoundingClientRect();

        if (bb.left < 0) {
            const triggerBB = this.$el.getBoundingClientRect();

            this._$content.style.left = `${-triggerBB.left}px`;

            // change size if too large for body
            if (this._$content.clientWidth > document.body.clientWidth) {
                this._$content.style.width = `${document.body.clientWidth}px`;
            }
        }
    }
}

// Event handlers
function onMouseEnter () {
    if (this._touched) return;
    this.visible = true;
}

function onMouseLeave () {
    // console.log('onMouseLeave', document.activeElement);
    if (!this._hasFocus) this.visible = false;
}

function onTouchStart () {
    this._touched = true;
}

function onClick (e) {
    console.log('click', !this.visible);
    e.preventDefault();
    this.visible = !this.visible;
}

function onChildFocus () {
    // console.log('onChildFocus');
    this.visible = true;
    this._hasFocus = true;
}

function onChildBlur () {
    // console.log('onChildBlur', e.currentTarget, e.relatedTarget, e.target, document.activeElement);

    if (this._hasFocus && !this.$el.contains(document.activeElement)) {
        this.visible = false;
        this._hasFocus = false;
    }
}

function onChildClick () {
    // console.log('onChildClick');
    // prevent staying visible on focus when mouse is used
    this._hasFocus = false;
}

function onFilterChange () {
    this.dispatch('change');
}
